import React from "react"
import ImageGallery from "react-image-gallery"
import CustomImage from "@/main/customImage"

import { Col } from "react-bootstrap"

function SinglePropertyCarousel({ property }) {
    const renderImage = (item) => {
        return (
            <div className="mx-auto property-carousel-main image-gallery-image">
                <CustomImage
                    src={item.original}
                    alt={item.originalAlt}
                    layout="fill"
                    objectFit="cover"
                    objectPosition="center"
                    sizes="100vw"
                    priority={item.priority}
                    allowFullScreen
                />
            </div>
        )
    }

    const renderThumb = (item) => {
        return (
            <div className="property-carousel-thumb">
                <CustomImage
                    src={item.thumbnail}
                    alt={item.thumbAlt}
                    layout="fill"
                    objectFit="cover"
                    objectPosition="center"
                    sizes="10vw"
                    // priority={item.priority}
                />
            </div>
        )
    }
    const images = property.images.map((image, index) => ({
        original: image.imgix_url,
        thumbnail: image.imgix_url,
        originalAlt: `Property ${property.property_ref} image ${index + 1}`,
        thumbAlt: `Property ${property.property_ref} image thumbnail ${
            index + 1
        }`,
        priority: index === 0,
        renderItem: renderImage,
        renderThumbInner: renderThumb,
        // description: image.image_text,
    }))

    return (
        <Col xs={12} className="px-0">
            <ImageGallery
                items={images}
                autoplay={false}
                showIndex={true}
                showPlayButton={false}
                lazyload={true}
            />
        </Col>
    )
}

export default SinglePropertyCarousel
